export const getQueryParameter = (name: string): string | null => {
  return new URLSearchParams(window.location.search).get(name)
}

export const removeQueryParam = (name: string): void => {
  const url = new URL(window.location.href)
  url.searchParams.delete(name)
  window.history.replaceState({}, '', url.toString())
}
